import React from 'react';
import PropTypes from 'prop-types';

import './VerticalAlign.scss';

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    offsetRatio: PropTypes.number,
    offset: PropTypes.number,
};

const defaultProps = {
    offsetRatio: 0,
    offset: 0,
};

class VerticalAlign extends React.Component {
    constructor(props) {
        super(props);

        this.children = props.children;

        this.state = {
            y: 0,
            containerHeight: window.innerHeight,
            contentHeight: '100%',
        };

        this.refChildren = React.createRef();
    }

    componentDidMount() {
        // The reason we are using a interval instead of onResize is because
        // the height of the container we are aligning might change at any time.
        const intervalId = setInterval(this.alignContent.bind(this), 100);
        this.intervalId = intervalId;
        this.alignContent();
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    alignContent = () => {
        let { offsetRatio, offset } = this.props;
        if (!offsetRatio) offsetRatio = 0;
        if (!offset) offset = 0;

        const screenDimensions = {
            width: window.innerWidth,
            height: window.innerHeight,
        };

        const contentDimensions = {
            width: this.refChildren.current.offsetWidth,
            height: this.refChildren.current.offsetHeight,
        };

        // only execute in case child content has more height than available screen space.
        if (contentDimensions.height > screenDimensions.height && contentDimensions.height - screenDimensions.height > 9) {
            // Not sure why we get black lines with a screen/content difference below this small amount of 9.
            // But we do. Fix this line some time in the future when we are not rushing for release.

            let overflowHeight = (contentDimensions.height - screenDimensions.height) / 2;

            if (offsetRatio > 0) {
                const ratio = screenDimensions.width / screenDimensions.height - offsetRatio;

                if (ratio > 0) {
                    overflowHeight += (1 + ratio) * offset;
                }
            }

            this.setState({
                y: 0 - overflowHeight,
                containerHeight: window.innerHeight,
                contentHeight: screenDimensions.height + overflowHeight,
            });
        } else {
            // if screen space is taller than children height. Draw children at top of screen.
            this.setState({
                y: 0,
                containerHeight: contentDimensions.height,
                contentHeight: contentDimensions.height,
            });
        }
    };

    render() {
        const { y, containerHeight, contentHeight } = this.state;

        return (
            <div
                className="VerticalAlign__content"
                style={{
                    transform: `translateY(${y}px)`,
                    height: containerHeight,
                }}
            >
                <div
                    className="VerticalAlign__children-outer"
                    style={{
                        height: contentHeight,
                    }}
                >
                    <div className="VerticalAlign__children-inner" ref={this.refChildren}>
                        {this.children}
                    </div>
                </div>
            </div>
        );
    }
}

VerticalAlign.propTypes = propTypes;
VerticalAlign.defaultProps = defaultProps;

export default VerticalAlign;
